import React from 'react'
import { Card } from '../ui/Card'

interface NoOrganizationMessageProps {
  message?: string
}

export function NoOrganizationMessage({
  message = 'Select an organization from the left menu.',
}: NoOrganizationMessageProps) {
  return (
    <div className="p-8 text-gray-500">
      {message}
    </div>
  )
}

interface ConnectionStatusCardProps {
  isConnected: boolean
  serviceName: string
  serviceDescription: string
  onConnect: () => void
  onDisconnect: () => void
  connectionDetails?: React.ReactNode
  brandColor?: string
}

export function ConnectionStatusCard({
  isConnected,
  serviceName,
  serviceDescription,
  onConnect,
  onDisconnect,
  connectionDetails,
  brandColor = '#4F46E5',
}: ConnectionStatusCardProps) {
  return (
    <Card className="mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Yhteystila</h2>
          {isConnected ? (
            <div className="mt-2">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5" />
                Yhdistetty
              </span>
              {connectionDetails && (
                <div className="mt-3">
                  {connectionDetails}
                </div>
              )}
            </div>
          ) : (
            <div className="mt-2">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                <span className="w-1.5 h-1.5 bg-gray-500 rounded-full mr-1.5" />
                Ei yhdistetty
              </span>
              <p className="mt-2 text-sm text-gray-600">
                {serviceDescription}
              </p>
            </div>
          )}
        </div>
        {isConnected ? (
          <button
            onClick={onDisconnect}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition"
          >
            Katkaise yhteys
          </button>
        ) : (
          <button
            onClick={onConnect}
            className="px-6 py-3 text-white rounded-lg hover:opacity-90 transition font-medium"
            style={{ backgroundColor: brandColor }}
          >
            Yhdistä {serviceName}
          </button>
        )}
      </div>
    </Card>
  )
}

interface SummaryFooterProps {
  count: number
  totalAmount: number
  formatAmount?: (amount: number) => string
}

export function SummaryFooter({
  count,
  totalAmount,
  formatAmount = (amount) => `${amount.toFixed(2)} €`,
}: SummaryFooterProps) {
  return (
    <div className="bg-gray-50 rounded-xl p-4 flex items-center justify-between text-sm text-gray-600">
      <span>Yhteensä {count} tapahtumaa</span>
      <span>
        Summa: {' '}
        <strong className="text-gray-900">{formatAmount(totalAmount)}</strong>
      </span>
    </div>
  )
}
